import { MetaFunction } from '@remix-run/node'
import { useOutletContext } from '@remix-run/react'
import clsx from 'clsx'
import { useEffect } from 'react'

import {
  MapListingCard,
  MapListingCardSkeleton,
  MapOutletContextData,
} from '~/components'
import { Button } from '~/components/ui'
import { useEmbed, useHasVisibleScrollBar } from '~/hooks'
import { debounce } from '~/utils'

export const meta: MetaFunction = () => [{ title: 'Card Search - Associate' }]

export default function MapCardsRoute() {
  const {
    listings,
    isError,
    isLoading,
    isFetching,
    fetchNextPage,
    hasNextPage,
  }: MapOutletContextData = useOutletContext()
  const hasVisibleScrollBar = useHasVisibleScrollBar()
  const { isEmbed, updateHostPageURL } = useEmbed()

  useEffect(() => {
    const elem = document.getElementById('map-cards-list')
    const onScroll = () => {
      if (
        hasNextPage &&
        !isFetching &&
        elem!.scrollTop > elem!.scrollHeight - elem!.scrollHeight / 4
      ) {
        fetchNextPage()
      }
    }
    const debouncedOnScroll = debounce(onScroll, 50)
    elem!.addEventListener('scroll', debouncedOnScroll)
    return () => elem!.removeEventListener('scroll', debouncedOnScroll)
  }, [hasNextPage, isFetching])

  useEffect(() => {
    if (isEmbed) {
      updateHostPageURL()
    }
  }, [isEmbed, updateHostPageURL])

  return (
    <div
      id="map-cards-list"
      className={clsx(
        'absolute bottom-0 left-0 right-0 top-16 z-30 grid place-content-start gap-4 overflow-auto pb-4 sm:top-18',
        '3xl:grid-cols-5 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-4',
        hasVisibleScrollBar ? 'pl-2 pr-0 sm:pl-4' : 'px-2 sm:px-4'
      )}>
      {isLoading
        ? Array.from({ length: 50 }, (value, index) => index).map((index) => {
            return (
              <MapListingCardSkeleton
                key={index}
                // className="2xl:w-72 md:w-72"
              />
            )
          })
        : listings.map((listing) => {
            return (
              <MapListingCard
                key={listing._id}
                className={clsx(
                  isFetching && 'animate-pulse'
                  // 'cursor-default'
                )}
                listing={listing}
              />
            )
          })}
      {hasNextPage && (
        <div className="col-span-full flex justify-center">
          <Button disabled={isFetching} onClick={() => fetchNextPage()}>
            {isFetching ? 'Loading' : 'Load More'}
          </Button>
        </div>
      )}
    </div>
  )
}
